var VrProductsBottom = function() {
    var _this = this,
        _allProductSelector,
        _allProductSelectorLength,
        _visibleProductSelector = $(".vr-products-bottom__products-wrapper .vr-product_none:visible"),
        _visibleProductsLength = _visibleProductSelector.length,
        iscrolShoppingList,
        _iscrolShoppingListArr = [],
        _visibleProductsIds,
        _numberOfAllBrProducts = $(".vr-products-bottom__container").data("products-number"),
        _gaEventCategory = '',
        _xmlBrochure = false;


    var isViewPage = page_name == 'brochure_view',
        isBrandCityPage = page_name == 'brand_city';

    if(page_name == 'brochure_view'){
        _gaEventCategory = 'brochure-view-';
    }else if(page_name == 'brand_city'){
        _gaEventCategory = 'brand-city-clicks-';
    }

    _gaEventCategory +=  (isMobile ? 'mobile' : 'desktop');

    function _activeBtn() {
        $("body").on("click", ".vr-product__btn", function() {
            if (isLogged) {

                var clickedProductName = $(this).closest(".vr-product").find(".vr-product__title_style").text();
                ga('send', 'event', _gaEventCategory, clickedProductName + '-shopping-list-add-button', window.location.href);

                $(this).toggleClass("vr-product__btn_active");
                $(this).closest(".vr-product").toggleClass("vr-product__liked");

                var productId = $(this).data("product-id"),
                    productOriginalId = $(this).data("original-id"),
                    productAction,
                    isXmlProduct = typeof $(this).data('is-xml') !== 'undefined' && $(this).data('is-xml') ? true : false;

                if ($(this).hasClass("vr-product__btn_active")) {
                    productAction = 1;
                    $(this).find("span").text(viewLang.added_product_text);
                } else {
                    productAction = 0;
                    $(this).find("span").text(viewLang.product_btn_add);
                }

                var productName = $(this).closest(".vr-product").find(".vr-product__title_style").text();

                $.ajax({
                    type: "POST",
                    url: "/products/shop_list_add_remove",
                    data: { "product_id": productId, "action": productAction, is_xml: isXmlProduct },
                    dataType: 'json',
                    success: function(data){
                        _addProductAjaxSuccess(data, productName, productAction);
                    },
                    error: function(err) {

                    }
                });
            }

        });
    }

    function _addProductAjaxSuccess(data, productName, productAction){
        if(data && data.status){

            var productShopList =
                '<div class="vr-shopping-list__item" data-action="1" data-id="' + data.product.id + '" data-original-id="' + data.product.id + '">' +
                '<div class="vr-shopping-list__item_label vr-shopping-list__item_bought">' + productName + '</div>' +
                '<div class="vr-shopping-list__item_logo" style="background-image: url(' + logoLinkView + ')"><a target="_blank" class="ignore-click" href="' + data.product.product_link + '"></a></div>' +
                '<div class="vr-shopping-list__item_controls">' +
                '<a class="vr-shopping-list_btn vr-shopping-list_btn_info ignore-click" data-action="info" target="_blank"' + ' href="' + data.product.product_link + '"></a>' +
                '<button class="vr-shopping-list_btn vr-shopping-list_btn_delete" type="button" data-action="0"></button>' +
                '</div>' +
                '</div>';

            if (productAction === 1) {
                $(".vr-shopping-list__buy_items .iscroll-inner").prepend(productShopList);
            } else {
                $(".vr-shopping-list__item[data-original-id='" + data.product.id + "']").remove();
            }

            _updateProductCnt();
            _showEmptyListMsgs();
            _iscrollShopList();
        }
    }    

    function _addNewProductInputFunk(newProduct) {
        newProduct = newProduct || "";

        if (newProduct.length > 0 && isLogged) {
            $.ajax({
                type: "POST",
                url: "/profile/add_in_shopping_list",
                data: { "name": newProduct },
                dataType: 'json',
                success: function(data) {

                    var productShopList =
                        '<div class="vr-shopping-list__item" data-action="1" data-id="' + data.product_id + '">' +
                        '<div class="vr-shopping-list__item_label vr-shopping-list__item_bought">' + newProduct + '</div>' +
                        '<div class="vr-shopping-list__item_controls">' +
                        '<a class="vr-shopping-list_btn vr-shopping-list_btn_search ignore-click" data-action="search" target="_blank"' + ' href="/search?search=' + newProduct + '"></a>' +
                        '<button class="vr-shopping-list_btn vr-shopping-list_btn_delete vr-shopping-list_item_input" type="button" data-action="0"></button>' +
                        '</div>' +
                        '</div>';

                    $(".vr-shopping-list__buy_items .iscroll-inner").prepend(productShopList);
                    $(".vr-shopping-list__middle input").val("");
                    _updateProductCnt();
                    _showEmptyListMsgs();
                    _iscrollShopList();

                    ga('send', 'event', _gaEventCategory, 'add-product-button-shopping-list', newProduct);

                },
                error: function(err) {

                }
            });
        }
    }

    function _addNewProductInput() {
        $(document).on('click', '.vr-shopping-list__btn', function(e) {
            var newProduct = $(this).closest('.vr-shopping-list__main').find(".vr-shopping-list__middle input").val().trim();
            _addNewProductInputFunk(newProduct);
        });

        $(document).on("keydown", ".vr-shopping-list__middle input", function(e) {
            if (e.keyCode == 13) {
                if (isLogged) {
                    var newProduct = $(e.target).val().trim();
                    _addNewProductInputFunk(newProduct);
                } else {
                    $('.vr-shopping-list__btn').click();
                }
            }
        });
    }

    function _removeProduct() {
        $(document).on("click", ".vr-shopping-list_btn_delete", function() {
            var removeProductId = $(this).closest(".vr-shopping-list__item").data('id'),
                removeProduct = $(".vr-shopping-list__item[data-id='" + removeProductId + "']"),
                removeProductId = removeProduct.data("id"),
                removeProductOriginalId = removeProduct.data("original-id"),
                isXmlProduct = typeof removeProduct.data('is-xml') !== 'undefined' && removeProduct.data('is-xml') ? true : false;


            if (removeProductOriginalId === "") {
                removeProductOriginalId = removeProduct.data("id");
            }

            if (!$(this).hasClass("vr-shopping-list_item_input")) { //product from brochure
                $.ajax({
                    type: "POST",
                    url: "/products/shop_list_add_remove",
                    data: { "product_id": removeProductOriginalId, "action": 0, is_xml: isXmlProduct },
                    dataType: 'json',
                    success: function(data) {

                        removeProduct.remove();
                        _updateProductCnt();
                        _showEmptyListMsgs();
                        _iscrollShopList();
                        $(".vr-product__btn[data-product-id='" + removeProductOriginalId + "']").removeClass("vr-product__btn_active");
                        $(".vr-product__btn[data-product-id='" + removeProductOriginalId + "'] span").text(viewLang.product_btn_add);

                    },
                    error: function(err) {

                    }
                });
            } else { // product from input
                $.ajax({
                    type: "POST",
                    url: "/profile/update_product_in_shopping_list",
                    data: { "product_id": removeProductId, "action": 0 },
                    dataType: 'json',
                    success: function(data) {

                        removeProduct.remove();
                        _updateProductCnt();
                        _showEmptyListMsgs();
                        _iscrollShopList();

                    },
                    error: function(err) {

                    }
                });

            }
        });
    }

    function _showMoreProducts() {
        $("body").on("click", ".vr-products-bottom__btn button", function() {

            _allProductSelector = $(".vr-products-bottom__products-wrapper .vr-product_none");
            _allProductSelectorLength = _allProductSelector.length;

            var $allVisibleProducts = $(".vr-products-bottom__products-wrapper .vr-product_none:visible");

            _visibleProductsIds = [];
            for (i = 0; i < _allProductSelectorLength; i++) {
                _visibleProductsIds.push(_allProductSelector.eq(i).data('product-id'));
            }

            if(gal.jsonData.type === ViewConsts.xml){
                _xmlBrochure = true;
            }

            _numberOfAddProducts = _visibleProductsLength - (_allProductSelectorLength - _visibleProductsLength);

            if (_visibleProductsLength === 8) {
                if ($allVisibleProducts.length > 8) {
                    _numberOfAddProducts = 8;
                } else {
                    _allProductSelector.addClass("vr-show");
                }
            }

            if (_visibleProductsLength === 6) {
                if ($allVisibleProducts.length > 6) {
                    _numberOfAddProducts = 6;
                } else {
                    _allProductSelector.addClass("vr-show");
                }
            }

            if (_visibleProductsLength === 4) {
                if ($allVisibleProducts.length > 4) {
                    _numberOfAddProducts = 4;
                } else {
                    _allProductSelector.addClass("vr-show");
                }
            }

            var data, ajaxUrl, dataArray = "products";

            if(page_name === "brand_city"){
                data = { "limit": _numberOfAddProducts, "brand_id": brandId, "excluded_products": _visibleProductsIds };
                ajaxUrl = "/brands/show_more_brand_products";
            }else{
                data = { "limit": _numberOfAddProducts, "brochure_id": brochureId, "excluded_products": _visibleProductsIds };
                ajaxUrl = "/products/show_more_products";
            }

            $.ajax({
                type: "POST",
                url: ajaxUrl,
                data: data,
                dataType: 'json',
                success: function(data) {
                    $.each(data[dataArray], function(i) {
                        if(typeof data[dataArray][i].path === 'undefined'){
                            return;
                        }
                        
                        var productImgUrl = typeof data[dataArray][i].path != 'undefined' ? data[dataArray][i].path : stati + '/img/upload/' + parseInt(data[dataArray][i].id_logo/1000) + '/' + data[dataArray][i].filename;

                        var productImg = '<div class="vr-product__image" style="background-image: url(' + productImgUrl + ')"><a target="_blank" href="' + data[dataArray][i].product_link + '"></a></div>';

                        var productTitle = '<div class="vr-product__title"><a target="_blank" href="' + data[dataArray][i].product_link + '" class="vr-product__title_style">' + data[dataArray][i].name + '</a></div>';

                        var productBtn = '<div class="vr-product__btn" data-product-id="' + data[dataArray][i].id + '"><span>' + viewLang.product_btn_add + '</span></div>';

                        var productTemplate = '<div class="col-xs-3 col-sm-4 col-md-3 col-lg-3 vr-product_none vr-show" data-product-id="' + data[dataArray][i].id + '"><div class="vr-product">' + productImg + productTitle + productBtn + '</div></div>';


                        if(_xmlBrochure){
                            productTemplate = productTemplate.replace('<div class="vr-product__btn"', '<div class="vr-product__btn" data-is-xml="1"');
                        }

                        $(".vr-products-bottom__products-wrapper").append(productTemplate);


                    });
                    if (!isLogged) {
                        $(".vr-product__btn").addClass("sh-profile-login");
                    }

                    // if (_numberOfAllBrProducts === $(".vr-product:visible").length) {
                    //     $(".vr-products-bottom__btn").hide();
                    // }
                    if(!data[dataArray].length || (data[dataArray].length<_numberOfAddProducts)) {
	                    $(".vr-products-bottom__btn").hide();
                    }
                },
                error: function(err) {

                }
            });
            //_visibleProductsIds = [];

            bLazy.revalidate();

            if(isViewPage){
                ga('send', 'event', _gaEventCategory, 'more-products-click-shopping-list', window.location.href);
            }else if(isBrandCityPage){
                ga('send', 'event', { eventCategory: _gaEventCategory, eventAction: 'more-products-down'});
            }
        });
    }

    function _showEmptyListMsgs() {
        var $toBuyList = $('.vr-shopping-list__buy_items'),
            $boughtList = $('.vr-shopping-list__bought_items'),
            showToBuyList = !$toBuyList.children().children().length,
            showBoughtList = !$boughtList.children().children().length;

        if ($toBuyList.next().is(':hidden') == true && showToBuyList || $toBuyList.next().is(':hidden') == false && showToBuyList == false) {
            $toBuyList.next().slideToggle();
        }

        if ($boughtList.next().is(':hidden') == true && showBoughtList || $boughtList.next().is(':hidden') == false && showBoughtList == false) {
            $boughtList.next().slideToggle();
        }
    }

    function _updateProductItemState() {
        $(document).on("click", ".vr-shopping-list__item", function(e) {

            var $el = $(e.target);

            var $item = $(this);
            var action = $item.data("action");
            var shopListProductId = $item.data("id");

            if ($el.hasClass('vr-shopping-list_btn_delete') || $el.hasClass('ignore-click')) {
                e.stopPropagation();

                return;
            }

            $.ajax({
                type: "POST",
                url: "/profile/update_product_in_shopping_list",
                data: { "product_id": shopListProductId, "action": action },
                dataType: 'json',
                success: function(data) {

                    var list = $item.closest('.vr-shopping-list__bought_items .iscroll-inner').length ? '.vr-shopping-list__buy_items .iscroll-inner' : '.vr-shopping-list__bought_items .iscroll-inner',
                        oldItemHolderList = $item.closest('.vr-shopping-list__bought_items .iscroll-inner').length ? '.vr-shopping-list__bought_items .iscroll-inner' : '.vr-shopping-list__buy_items .iscroll-inner';


                    $item.stop().slideToggle(200, function() {
                        $item.prependTo(list);

                        $item = $(list + ' .vr-shopping-list__item[data-id="' + shopListProductId + '"]');
                        $item.stop().slideToggle(200);

                        $(oldItemHolderList + ' .vr-shopping-list__item[data-id="' + shopListProductId + '"]').remove();

                        _showEmptyListMsgs();
                        _iscrollShopList();
                    });

                },
                error: function(err) {

                }
            });
        })
    }

    function _updateProductCnt() {
        $('.vr-shopping-list__main_title span').text('(' + $('.vr-shopping-list__main:first .vr-shopping-list__item').length + ')');

        if ($('.vr-shopping-list__item').length === 0) {
            $('.vr-shopping-list__main').addClass('vr-no-products')
        } else {
            if ($('.vr-shopping-list__main').hasClass('vr-no-products')) {
                $('.vr-shopping-list__main').removeClass('vr-no-products')
            }
        }
    }

    function _iscrollShopList() {

        if ($(".vr-shopping-list__buy .vr-shopping-list__item").length > 4 && $(".vr-shopping-list__buy .iScrollVerticalScrollbar").length === 0) {

            $(".vr-shopping-list__buy_items").each(function(inx, itemToScroll){
                _iscrolShoppingListArr.push(
                    new IScroll(itemToScroll, {
                        scrollbars: true,
                        interactiveScrollbars: true,
                        click: true,
                        mouseWheel: true,
                        resizeScrollbars: false,
                        draggable: false,
                    })
                );
            });
        }

        if ($(".vr-shopping-list__bought .vr-shopping-list__item").length > 4 && $(".vr-shopping-list__bought .iScrollVerticalScrollbar").length === 0) {

            $(".vr-shopping-list__bought_items").each(function(inx, itemToScroll){
                _iscrolShoppingListArr.push(
                    new IScroll(itemToScroll, {
                        scrollbars: true,
                        interactiveScrollbars: true,
                        click: true,
                        mouseWheel: true,
                        resizeScrollbars: false,
                        draggable: false,
                    })
                );
            });
        }

        if ($(".vr-shopping-list__buy .iScrollVerticalScrollbar").length > 0) {

            setTimeout(function() {
                $.each(_iscrolShoppingListArr, function(inx, iScrollItem){
                    iScrollItem.refresh();
                });

                if ($(".vr-shopping-list__buy .iScrollLoneScrollbar").length > 0 && $(".vr-shopping-list__buy .vr-shopping-list__item").length <= 4) {
                    $(".vr-shopping-list__buy .iScrollLoneScrollbar").removeClass("iScrollLoneScrollbar");
                    $(".vr-shopping-list__buy").find(".iScrollIndicator").removeClass("iScrollIndicator");
                    $(".vr-shopping-list__buy").find(".iScrollVerticalScrollbar").removeClass("iScrollVerticalScrollbar");
                }
            }, 300);
        }

        if ($(".vr-shopping-list__bought .iScrollVerticalScrollbar").length > 0) {

            setTimeout(function() {
                _iscrolShoppingListArr.forEach(function(iScrollItem, inx){
                    iScrollItem.refresh();
                });

                if ($(".vr-shopping-list__bought .iScrollLoneScrollbar").length > 0 && $(".vr-shopping-list__bought .vr-shopping-list__item").length <= 4) {
                    $(".vr-shopping-list__bought .iScrollLoneScrollbar").removeClass("iScrollLoneScrollbar");
                    $(".vr-shopping-list__bought").find(".iScrollIndicator").removeClass("iScrollIndicator");
                    $(".vr-shopping-list__bought").find(".iScrollVerticalScrollbar").removeClass("iScrollVerticalScrollbar");
                }
            }, 300);
        }

    }

    function _init() {
        _activeBtn();
        _showMoreProducts();
        _addNewProductInput();
        _removeProduct();
        _updateProductCnt();
        _updateProductItemState();
        _iscrollShopList();

        $(document).on("click", ".vr-product__image a", function() {
            if(isViewPage){
                ga('send', 'event', _gaEventCategory, $(this).closest(".vr-product").find(".vr-product__title_style").text() + '-shopping-list-image', window.location.href);
            }else if(isBrandCityPage){
                ga('send', 'event', _gaEventCategory, 'similar-brochure-native-product-text', $(this).closest(".vr-product").find(".vr-product__title_style").text());
            }
        });

        if(isBrandCityPage){
            $(document).on("click", ".vr-product__image a", function() {

            });
        }

        $(document).on("click", ".vr-product__title_style", function() {
            if(isViewPage){
                ga('send', 'event', _gaEventCategory, $(this).closest(".vr-product").find(".vr-product__title_style").text() + '-shopping-list-text', window.location.href);
            }else if(isBrandCityPage){
                ga('send', 'event', _gaEventCategory, 'product-image-down-click', $(this).closest(".vr-product").find(".vr-product__title_style").text());
            }
        });
        $(document).on("click", ".vr-shopping-list__middle input", function(e) {
            ga('send', 'event', _gaEventCategory, 'add-product-plus-click-shopping-list-' + (isLogged ? 'loggedin' : 'loggedout'), window.location.href);
        });

        if(isMobile && $(".vr-products-bottom__container .vr-banner-mobile").length !== 0){

            function bannerProducts(x) {

                var selector = ".vr-products-bottom__container .vr-banner-mobile-container";
                var thirdProduct = $(".vr-products-bottom__container .vr-product_none").eq(2);
                var fourthProduct = $(".vr-products-bottom__container .vr-product_none").eq(3);

                thirdProduct.detach();
                fourthProduct.detach();

                if(two.matches){         // 520 -->      2 on row
                    thirdProduct.insertAfter(selector);
                    fourthProduct.insertAfter(selector);

                }else if(three.matches){ // 520 - 690      3 on row
                    thirdProduct.insertBefore(selector);
                    fourthProduct.insertAfter(selector);

                }else if(four.matches){ // 690 - 830      3 on row
                    thirdProduct.insertBefore(selector);
                    fourthProduct.insertBefore(selector);

                }else if(twoShop.matches){ // 768 - 900      2 on row with shoplist
                    thirdProduct.insertAfter(selector);
                    fourthProduct.insertAfter(selector);

                }else if(threeShop.matches){ // 900 - 1024    3 on row with shoplist
                    thirdProduct.insertBefore(selector);
                    fourthProduct.insertAfter(selector);

                }else{                   //830      4 on row
                    thirdProduct.insertBefore(selector);
                    fourthProduct.insertBefore(selector);
                }
            }

            var two = window.matchMedia("(max-width: 520px)");
            var three = window.matchMedia("(max-width: 690px)");
            var four = window.matchMedia("(max-width: 767px)");
            var twoShop = window.matchMedia("(max-width: 900px)");
            var threeShop = window.matchMedia("(max-width: 1023px)");
            bannerProducts(two);
            bannerProducts(three);
            bannerProducts(four);
            bannerProducts(twoShop);
            bannerProducts(threeShop);
            two.addListener(bannerProducts); 
            three.addListener(bannerProducts);
            four.addListener(bannerProducts);
            twoShop.addListener(bannerProducts);
            threeShop.addListener(bannerProducts);
        }

    }

    _init();

    _this.init = _init;
    _this.iscrollShopList = _iscrollShopList;
    _this.showMoreProducts = _showMoreProducts;
};